import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-premium-tooltip',
  imports: [],
  templateUrl: './premium-tooltip.component.html',
  styleUrl: './premium-tooltip.component.scss'
})
export class PremiumTooltipComponent {
  @Input() text: string = '';
  @Input() width: string = '306px';
}
